<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1>Transfer Balance</h1>
            </div>
        <div class="section-body">
            <div class="row justify-content-md-center">
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Transfer</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>*Dari Akun</label>
                                <select id="akun_bayar" v-model="dari_akun" class="form-control">
                                        <option disabled value="">--Pilih Akun--</option>
                                        <option v-for="option in akunBayarList" v-bind:key="option.id_coa" :value="option.id_coa">({{option.kode_akun}}) - {{ option.nama_akun}} ({{option.deskripsi}})</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>*Ke AKun</label>
                                <select id="akun_bayar" v-model="ke_akun" class="form-control">
                                        <option disabled value="">--Pilih Akun--</option>
                                        <option v-for="option in akunBayarList" v-bind:key="option.id_coa" :value="option.id_coa">({{option.kode_akun}}) - {{ option.nama_akun}} ({{option.deskripsi}})</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Tanggal Transfer</label>
                                <vc-date-picker v-model="tanggal_transfer" :input-props='{class: "form-control",placeholder: "Masukkan tanggal transfer",style:"text-align:center;vertical-align:middle"}'/>
                            </div>
                            <div class="form-group">
                                <label>*Total Transfer</label>
                                <input type="number" v-model="total_transfer" required class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Keterangan</label>
                                <textarea class="form-control" required v-model="keterangan" ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button @click="submit()" class="btn btn-primary">Transfer</button>
                    <button @click="$router.go(-1)" class="btn btn-danger">Kembali</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<script>
export default {
    data() {
        return {
            akunList : [],
            akunBayarList : [],
            dari_akun : '',
            ke_akun : '',
            total_transfer : 0,
            keterangan : '',
            tanggal_transfer : ''
        }
    },
    mounted() {
        // get coa/akun list
        this.$http.post("Datalist/getCoa").then(result => {
            if(result.data.code == '00') {
                alert('failed get coa')
            }
            else {
                this.akunList = result.data.detail;
                this.akunBayarList = this.filterArr(this.akunList,'id_kategori','3');
                // this.akunJualList = this.filterArr(this.akunList,'id_kategori','13')
            }
        }, error => {
            console.log('gk ok')
            context.errors = errors;
        });
    },
    methods: {
        filterArr: function(array,prop,value) {
            var filtered = [];
            for(var i = 0; i < array.length; i++){
                if(array[i][prop] == value){
                    filtered.push(array[i])
                }
            }    
            return filtered;
        },
        submit: function()
        {
            if(this.dari_akun == '' || this.ke_akun == '')
            {
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Tolong pilih akun bayar !',
                    type : 'warning'
                }
                return false
            }

            if(this.total_transfer == '' || this.total_transfer <= 0)
            {
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Masukkan jumlah transfer yang benar',
                    type : 'warning'
                }
                return false
            }

            var formsub = new FormData();
            formsub.append('dari_akun',this.dari_akun);
            formsub.append('ke_akun',this.ke_akun);
            formsub.append('total_transfer',this.total_transfer);
            formsub.append('keterangan',this.keterangan);
            formsub.append('tanggal_transfer', this.formatDate(this.tanggal_transfer));

            this.$http.post("Finance/transferBalance", formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Saldo Berhasil di transfer !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.$router.go(-1)
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Transaksi gagal silahkan hubungi operator !',
                        type : 'error'
                    }                    
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
            });
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/daftar/TransferBalance.vue